import React from 'react';
import './Pages.css';

const Datenschutz = () => {
  return (
    <div className="page datenschutz-page">
      <style>{`
        .datenschutz-page .page-header { background: #008F99; color: #ffffff; }
        .datenschutz-page .page-title { color: #ffffff; }
        .datenschutz-page .content-section .container { text-align: center; }
        .datenschutz-page .content-section h3 { margin-top: 32px; margin-bottom: 12px; }
        .datenschutz-page .content-section h3:first-of-type { margin-top: 0; }
        .datenschutz-page .content-section p { margin-top: 0; margin-bottom: 14px; }
      `}</style>
      <section className="page-header">
        <div className="container">
          <div className="page-title">Datenschutzerklärung</div>
        </div>
      </section>
      
      <section className="content-section">
        <div className="container">
          <h3>1. Verantwortlicher</h3>
          <p>
            <strong>MINTkitchen KG</strong><br />
            Amselweg 22<br />
            33178 Borchen, Deutschland<br />
            Kontakt: <a href="/kontakt">Kontaktformular</a>
          </p>

          <h3>2. Hosting und Bereitstellung</h3>
          <p>
            Unsere Website wird in der Cloud-Infrastruktur von <strong>Amazon Web Services (AWS)</strong> betrieben. Beim Aufruf der Seiten werden
            technisch bedingt Verbindungsdaten (z. B. IP-Adresse, Zeitpunkt, User-Agent) verarbeitet, um die Website auszuliefern und Stabilität
            sowie Sicherheit zu gewährleisten.
          </p>
          <p>
            Primäre AWS-Region: <strong>Irland (eu-west-1)</strong>. Hiervon ausgenommen sind global bereitgestellte AWS-Dienste, die
            regionsübergreifend betrieben werden können.
          </p>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und effizienten Bereitstellung).
            AWS verarbeitet Daten als Auftragsverarbeiter auf Grundlage eines Auftragsverarbeitungsvertrags (Art. 28 DSGVO) und – soweit erforderlich –
            Standardvertragsklauseln bei Übermittlungen in Drittländer.
          </p>

          <h3>3. Server-Logfiles</h3>
          <p>
            Beim Aufruf unserer Website können Server-Logfiles anfallen (z. B. IP-Adresse, Datum/Uhrzeit, Referrer, User-Agent). Diese Daten werden
            ausschließlich zur Sicherstellung des technischen Betriebs, zur Fehleranalyse und zur Abwehr von Angriffen verarbeitet und regelmäßig
            automatisiert gelöscht.
          </p>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h3>4. Kontaktformular</h3>
          <p>
            Wenn Sie uns über das <a href="/kontakt">Kontaktformular</a> eine Nachricht senden, verarbeiten wir die von Ihnen eingegebenen Daten
            (z. B. Name, E‑Mail, Unternehmen, Telefon, Betreff, Nachricht). Zusätzlich setzen wir technische Schutzmaßnahmen (Honeypot-Felder,
            Mindest-Ausfüllzeit), um missbräuchliche automatisierte Eingaben zu erkennen.
          </p>
          <p>
            <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage und Kommunikation.<br />
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) und/oder Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effektiver Kommunikation).<br />
            <strong>Speicherdauer:</strong> Wir löschen Anfragen, sobald diese abschließend beantwortet sind, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
          </p>

          <h3>5. Kurs-Anmeldung</h3>
          <p>
            Bei der Anmeldung zu unseren Kursen verarbeiten wir die hierfür notwendigen Daten (z. B. Vorname, Nachname, E‑Mail, Unternehmen, Telefon,
            optionale Angaben sowie kursbezogene Informationen). Die Daten werden in unseren Backend-Systemen innerhalb der AWS-Cloud verarbeitet und
            gespeichert. Eine Weitergabe erfolgt nur, soweit dies für die Durchführung des Kurses erforderlich ist (z. B. an Dozierende oder unmittelbar
            beteiligte Projektpartner).
          </p>
          <p>
            <strong>Zweck:</strong> Durchführung und Verwaltung der Kursanmeldung sowie Kommunikation hierüber.<br />
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Vorbereitung des Vertrags).<br />
            <strong>Speicherdauer:</strong> Für die Dauer der Vertragsdurchführung sowie gemäß gesetzlichen Aufbewahrungsfristen (insb. handels- und steuerrechtlich).
          </p>

          <h3>6. Cookies</h3>
          <p>
            Wir setzen derzeit keine Tracking- oder Marketing-Cookies ein. Es können technisch notwendige Cookies verwendet werden, die für den Betrieb
            der Website erforderlich sind.
          </p>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Betrieb und Sicherheit der Website).
          </p>

          <h3>7. Analysen/Tracking</h3>
          <p>
            Wir verwenden <strong>Matomo Cloud</strong> (https://matomo.cloud/) zur Analyse der Website-Nutzung. Matomo ist ein datenschutzfreundliches 
            Analysetool, das ohne Cookies arbeitet und Ihre Privatsphäre respektiert.
          </p>
          <p>
            <strong>Verarbeitete Daten:</strong> Anonymisierte Nutzungsstatistiken (z. B. Seitenaufrufe, Verweildauer, Herkunft), 
            IP-Adresse (anonymisiert), technische Informationen (Browser, Betriebssystem, Gerätetyp).
          </p>
          <p>
            <strong>Zweck:</strong> Verbesserung der Website-Performance und Benutzerfreundlichkeit, Analyse der Nutzungsgewohnheiten.
          </p>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) - Sie können der Analyse jederzeit über die 
            Datenschutz-Einstellungen widersprechen.
          </p>
          <p>
            <strong>Speicherdauer:</strong> 24 Monate (anonymisiert).<br />
            <strong>Datenübertragung:</strong> Matomo Cloud (Deutschland/EU), Auftragsverarbeiter gemäß Art. 28 DSGVO.
          </p>
          <p>
            <strong>Ihre Rechte:</strong> Sie können die Analyse jederzeit über das Datenschutz-Symbol unten links deaktivieren oder 
            Ihre Einwilligung widerrufen. Matomo respektiert "Do Not Track"-Einstellungen Ihres Browsers.
          </p>

          <h3>8. Empfänger und Kategorien von Empfängern</h3>
          <p>
            – Amazon Web Services (AWS) als Hosting-/Backend-Dienstleister (Auftragsverarbeiter).<br />
            – Matomo Cloud als Analysedienstleister (Auftragsverarbeiter gemäß Art. 28 DSGVO).<br />
            – Ggf. Dozierende/Projektpartner, soweit dies zur Durchführung der Kurse notwendig ist.
          </p>

          <h3>9. Drittlandübermittlung</h3>
          <p>
            Eine Datenverarbeitung durch AWS findet bevorzugt innerhalb der EU/des EWR statt. Matomo Cloud verarbeitet Daten ausschließlich 
            innerhalb der EU/des EWR (Deutschland). Soweit in Einzelfällen eine Übermittlung in Drittländer erfolgt, erfolgt diese auf Grundlage 
            geeigneter Garantien (insb. EU-Standardvertragsklauseln) gemäß Art. 46 DSGVO.
          </p>

          <h3>10. Sicherheit der Verarbeitung</h3>
          <p>
            Wir treffen geeignete technische und organisatorische Maßnahmen (TOM), um ein dem Risiko angemessenes Schutzniveau zu gewährleisten
            (u. a. Zugriffsbeschränkungen, Verschlüsselung während der Übertragung, rollenbasierte Zugriffe in Backend-Systemen).
          </p>

          <h3>11. Ihre Rechte</h3>
          <p>
            Sie haben gegenüber dem Verantwortlichen folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
          </p>
          <ul style={{ listStyle: 'disc', paddingLeft: '20px', textAlign: 'left', margin: '0 auto', display: 'inline-block' }}>
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
            <li>Recht auf Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
          </ul>
          <p>
            Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren
            (Art. 77 DSGVO), insbesondere in dem Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen
            Verstoßes.
          </p>

          <h3>12. Pflicht zur Bereitstellung</h3>
          <p>
            Im Rahmen der Kursanmeldung sind bestimmte Angaben erforderlich, um den Vertrag zu schließen bzw. vorzubereiten. Ohne diese Angaben
            kann eine Anmeldung ggf. nicht bearbeitet werden.
          </p>

          <h3>13. Aktualität</h3>
          <p>
            Diese Datenschutzerklärung ist aktuell und hat den Stand <strong>15.01.2025</strong>. Wir behalten uns vor, die Erklärung
            bei Bedarf zu aktualisieren, um Änderungen unserer Datenverarbeitung oder der Rechtslage zu berücksichtigen.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;
